import { register, findAll } from '../../../../Javascript/Sysmex/Utils'

/* Temporary polyfill for the .forEach loop of node lists for IE11. To fix permanently, rewrite all findAll to deliver arrays. Or wait for IE11 to die. */
const NodeList = window.NodeList
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach
}

const OffCanvasNavigation = el => {
  document.navigationPrefix = el.getAttribute('data-prefix')
  const triggerLinks = findAll('.' + document.navigationPrefix + 'navigationItem', el)
  const backLinks = findAll('.' + document.navigationPrefix + 'navigationBackLink', el)

  triggerLinks.forEach(function (el) {
    el.addEventListener('click', event => {
      triggerMenu(event, el)
    })
  })

  backLinks.forEach(function (el) {
    el.addEventListener('click', backMenu.bind(this, el))
  })
}

const triggerMenu = (event, el) => {
  if (el.children[0].classList.contains(document.navigationPrefix + 'hasChevron')) {
    event.preventDefault()
  }
  let triggerClass = el.classList.value
  triggerClass += 'Active'
  el.classList.add(triggerClass)
}

const backMenu = el => {
  el.parentElement.previousElementSibling.classList.remove(document.navigationPrefix + 'navigationItemActive')
}

register('OffCanvasNavigation', OffCanvasNavigation)
